import { TextLinkList, SectionTitle, Text } from '@doda/io-react/common';
import { JobContentLinkList } from '@doda/common/src/types/jobSearchList/jobContent/jobContentLink';
import { JOB_CONTENT_LINK } from '@doda/common/src/constants/jobSearchList/jobContent/jobContentLink';
import { measureLinkButtonClick } from '@doda/common/src/logics/jobSearchList/jobContentLinkAnalytics';
import { useRef } from 'react';
import styles from './index.module.scss';

/**
 * JobContentLinkのProps
 * @property jobContentLinks リンク先1カテゴリ単位の求人コンテンツリンク
 */
interface JobContentLinkProps {
  jobContentLinks: JobContentLinkList;
}

/**
 * 求人コンテンツリンク
 */
export const JobContentLink = ({ jobContentLinks }: JobContentLinkProps) => {
  const isLinkClickedRef = useRef(false);
  const { category, links } = jobContentLinks;

  if (!links || links.length === 0) return null;

  const handleClickLink = () => {
    if (isLinkClickedRef.current) return;
    isLinkClickedRef.current = true;
    measureLinkButtonClick(category);
  };

  return (
    <div>
      <SectionTitle as="h2" bgType="none" size="XL">
        {JOB_CONTENT_LINK[category].title}
      </SectionTitle>
      <Text
        color="black_pc"
        size="14--articlePC"
        className="job-content-link__summary"
      >
        {JOB_CONTENT_LINK[category].summary}
      </Text>
      <div className={styles['job-content-link__list']}>
        {links.map((item) => (
          <TextLinkList
            key={item.url}
            columnCount="1"
            listData={[
              {
                href: item.url,
                text: item.label,
                onClick: handleClickLink,
              },
            ]}
            rounded
            arrow="blue"
            shadow="blue"
            className="job-content-link__item"
          />
        ))}
      </div>
    </div>
  );
};
